import {
	PropsWithChildren,
	ReactElement,
	FormEvent
} from "react";
import classnames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import styles from "./Form.module.less";

export type FormProps = {
	onSubmit: (() => void) | "NONE";
	hasWidthConstrained?: boolean;
	height?: "auto" | "fill";
	trackingId?: string;
};

export const Form = (props: PropsWithChildren<FormProps>): ReactElement => {
	const {
		hasWidthConstrained = false,
		height = "auto",
		onSubmit,
		children,
		trackingId
	} = props;

	const submitHandler = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		if (onSubmit !== "NONE") {
			onSubmit();
		}
	};

	return (
		<form
			{...setTrackingId(trackingId)}
			className={
				classnames(
					styles.root,
					{
						[styles.root_widthConstrained]: hasWidthConstrained,
						[styles.root_fillHeight]: height === "fill"
					}
				)
			}
			onSubmit={submitHandler}
			noValidate
		>
			{ children }
			<button type="submit" className={styles.hiddenSubmitButton} tabIndex={-1} />
		</form>
	);
};
Form.displayName = "Form";
